export default __webpack_public_path__ + "static/media/gcp_logo.0d29293e.png";